<template>
    <transition name="fade">
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-index-2">
        <div class="bg-white rounded-lg p-4 w-full max-w-lg">
          <form @submit.prevent="submitForm">
            <div class="mb-4">
              <label for="nombre" class="block text-sm font-medium text-gray-700">Nombre del recinto</label>
              <input type="text" id="nombre" v-model="form.nombre" class="input-style" required>
            </div>
            <div class="mb-4">
              <label for="ubicacion" class="block text-sm font-medium text-gray-700">Ubicación</label>
              <textarea id="ubicacion" v-model="form.ubicacion" class="input-style" rows="3"></textarea>
            </div>
            <div class="flex justify-end">
              <button type="button" @click="$emit('close')" class="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded">Cancelar</button>
              <button type="submit" class="ml-5 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                {{ form.id_recinto ? 'Guardar Cambios' : 'Crear Recinto' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </transition>
  </template>
  
  <script setup>
  import { ref, watch, defineProps, defineEmits } from 'vue';
  import { useToast } from "vue-toastification";
  const props = defineProps({
    recinto: { type: Object, default: null }
  });
  const emit = defineEmits(['close', 'saved']);
  const toast = useToast();
  
  const form = ref({
    id_recinto: null,
    nombre: '',
    ubicacion: '',
  });
  
  watch(() => props.recinto, (val) => {
    if (val) form.value = { ...val };
    else form.value = { id_recinto: null, nombre: '', ubicacion: '' };
  }, { immediate: true });
  
  function submitForm() {
    const method = form.value.id_recinto ? 'PUT' : 'POST';
    const url = form.value.id_recinto
      ? `/api/recintos/${form.value.id_recinto}`
      : '/api/recintos';
  
    fetch(url, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form.value)
    })
      .then(res => res.json())
      .then(() => {
        toast.success(form.value.id_recinto ? "Recinto actualizado" : "Recinto creado");
        emit('saved');
        emit('close');
      })
      .catch(() => {
        toast.error("Error al guardar el recinto");
      });
  }
  </script>
  
  <style lang="sass" scoped>
  .input-style
    display: block
    width: 100%
    padding: 0.625rem
    border: 1px solid #cccccc
    border-radius: 0.375rem
    box-shadow: inset 0 1px 1px rgba(0,0,0,0.075)
    &:focus
      outline: none
      border-color: #3182ce
      ring: #3182ce
  
  .fade-enter-active, .fade-leave-active
    transition: opacity 0.5s
  .fade-enter, .fade-leave-to
    opacity: 0
  .z-index-2
    z-index: 2
  </style>
  